import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight, FiKey, FiMoon, FiPhone, FiSend, FiSun } from "react-icons/fi";
import Layout from "./Layout";
import { normalizePhone } from "../utils/normalizeDigits";
import useAuthTheme from "./useAuthTheme";
import "./auth.css";
import "../pages/dashboard.css";

const API_BASE = (process.env.REACT_APP_API_URL || "/api/v1").replace(/\/$/, "");

export default function ForgotPassword() {
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [theme, setTheme] = useAuthTheme();
  const navigate = useNavigate();

  const validate = () => {
    const finalPhone = normalizePhone(phone);

    // دانش‌آموز: 0912...
    // کارکنان: 912...
    if (!/^0?9\d{9}$/.test(finalPhone)) return "شماره تلفن معتبر نیست.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const err = validate();
    if (err) {
      setMessage(err);
      setIsError(true);
      return;
    }

    const finalPhone = normalizePhone(phone);

    setLoading(true);
    setMessage("در حال ارسال کد...");
    setIsError(false);

    try {
      const res = await fetch(`${API_BASE}/password/forgot`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: finalPhone }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setMessage(data.detail || data.message || "خطا در ارسال کد");
        setIsError(true);
        setLoading(false);
        return;
      }

      setMessage("کد ارسال شد.");
      setIsError(false);
      setLoading(false);

      navigate("/reset-password", {
        state: {
          phone: finalPhone,
          otp: data.dev_otp || null,
        },
      });
    } catch (err) {
      console.error("ForgotPassword error:", err);
      setMessage("خطا در اتصال به سرور");
      setIsError(true);
      setLoading(false);
    }
  };

  return (
    <Layout className="login-auth-wrapper recovery-auth-wrapper" cardClassName="login-card register-card recovery-card">
      <div className="register-toolbar">
        <button type="button" className="register-icon-button" onClick={() => navigate("/auth/login")} aria-label="بازگشت به ورود"><FiArrowRight /></button>
        <button type="button" className="register-icon-button" onClick={() => setTheme((value) => value === "dark" ? "light" : "dark")} aria-label="تغییر پوسته">{theme === "dark" ? <FiSun /> : <FiMoon />}</button>
      </div>

      <div className="recovery-heading"><span><FiKey /></span><div><h1>بازیابی رمز عبور</h1><p>شماره تلفن حساب خود را وارد کنید تا کد تأیید برای شما ارسال شود.</p></div></div>
      <div className="recovery-steps" aria-label="مراحل بازیابی"><span className="is-active"><b>۱</b> شماره تماس</span><i /><span><b>۲</b> رمز جدید</span></div>

      <form className="recovery-form" onSubmit={handleSubmit} noValidate>
        <label htmlFor="recovery-phone">شماره تلفن</label>
        <div className="register-input-icon"><FiPhone /><input
          id="recovery-phone"
          type="text"
          inputMode="numeric"
          autoComplete="tel"
          maxLength={11}
          placeholder="مثلاً 09121234567"
          value={phone}
          onChange={(e) => setPhone(normalizePhone(e.target.value))}
        /></div>
        {message && <div className={`login-message ${isError ? "is-error" : "is-info"}`} role={isError ? "alert" : "status"}>{message}</div>}
        <button className="recovery-submit" type="submit" disabled={loading}>
          {loading ? <><span className="login-spinner" /> در حال ارسال...</> : <><FiSend /> ارسال کد تأیید</>}
        </button>
      </form>
    </Layout>
  );
}
